module.exports = __webpack_public_path__ + "media/images/lb/219-9bd6e3095c581f7b672374aff53eb1c1.svg";